import type { ConversationAction, ConvoStarterCategoriesMap } from '../../types';
import { isChatAction } from '../index';

export const createJTBDCategoryMap = (
	dynamicConvoActions: ConversationAction[],
): ConvoStarterCategoriesMap =>
	dynamicConvoActions.reduce((map, action: ConversationAction) => {
		if (!isChatAction(action) || !action.jtbdCategory) {
			return map;
		}
		if (!map[action.jtbdCategory]) {
			map[action.jtbdCategory] = 1;
		} else {
			map[action.jtbdCategory] += 1;
		}
		return map;
	}, {} as ConvoStarterCategoriesMap);
